import type { FactoryRun, StageAction } from '@/lib/types';

// All action handlers are stubs this session — they console.log the intent
// and take no other effect. A follow-up bullet will wire them to Firestore
// writes against factory_runs (for approve/reject/pause/archive) and
// factory_runs/{runId}/founder_messages (for sending).
//
// Keeping them centralized here so the follow-up PR has exactly one place
// to flip from console.log → addDoc/updateDoc.

export function stubStageAction(action: StageAction, run: FactoryRun): void {
  console.log(
    `[rta-systems-v1 stub] ${action.toUpperCase()} requested for run`,
    run.id,
    `(customer: ${run.customerName ?? run.customerId ?? '?'}, stage: ${run.currentStage}, status: ${run.status})`,
    '— no Firestore write performed',
  );
}

export function stubSendFounderMessage(runId: string, text: string): void {
  console.log(
    `[rta-systems-v1 stub] SEND founder message to run ${runId}:`,
    text,
    '— no Firestore write performed',
  );
}

export function stubNewThread(): void {
  console.log(
    '[rta-systems-v1 stub] NEW THREAD requested — no Firestore write performed',
  );
}
